import request from '@/utils/request'

function unwrap(promise, fallbackMessage) {
  return promise.then(response => {
    const res = response.data
    if (res.code === 0) return res
    throw new Error(res.msg || fallbackMessage)
  })
}

export function listPlates(params) {
  return unwrap(request({
    url: '/aggregateCode.listPlates',
    method: 'post',
    data: params
  }), '获取码牌列表失败')
}

export function savePlate(data) {
  return unwrap(request({
    url: '/aggregateCode.savePlate',
    method: 'post',
    data
  }), '保存码牌失败')
}

export function updatePlate(data) {
  return unwrap(request({
    url: '/aggregateCode.updatePlate',
    method: 'post',
    data
  }), '更新码牌失败')
}

export function bindPlate(data) {
  return unwrap(request({
    url: '/aggregateCode.bindPlate',
    method: 'post',
    data
  }), '绑定失败')
}

export function listBindings(params) {
  return unwrap(request({
    url: '/aggregateCode.listBindings',
    method: 'post',
    data: params
  }), '获取绑定记录失败')
}

export function listRouteConfigs(params) {
  return unwrap(request({
    url: '/aggregateCode.listRouteConfigs',
    method: 'post',
    data: params
  }), '获取路由配置失败')
}

export function saveRouteConfig(data) {
  return unwrap(request({
    url: '/aggregateCode.saveRouteConfig',
    method: 'post',
    data
  }), '保存路由配置失败')
}

export function listScanEvents(params) {
  return unwrap(request({
    url: '/aggregateCode.listScanEvents',
    method: 'post',
    data: params
  }), '获取扫码事件失败')
}

export function listOperationLogs(params) {
  return unwrap(request({
    url: '/aggregateCode.listOperationLogs',
    method: 'post',
    data: params
  }), '获取操作记录失败')
}
